import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Grid2X2, Circle } from 'lucide-react';

// Only destinations supplied by the permission-filtered navigation are eligible.
export function mobileWorkspaceItems(modules = []) {
  const items = modules.flatMap(group => group.items || []);
  return [['/dashboard', 'Painel'], ['/chats', 'Atender'], ['/gestor-xui/clients', 'Clientes'], ['/gestor-xui/resellers', 'Revendas']]
    .map(([path, label]) => { const item = items.find(entry => entry.path === path); return item ? { ...item, shortLabel: label } : null; })
    .filter(Boolean);
}

export default function OfficeMobileNavigation({ modules, badges = {}, onMenu, expanded }) {
  const items = mobileWorkspaceItems(modules);
  const { pathname } = useLocation();
  const otherPage = !items.some(item => pathname === item.path || pathname.startsWith(item.path + '/'));
  return <nav data-testid="office-bottom-nav" className="office-mobile-navigation" aria-label="Navegação rápida" style={{ '--mobile-navigation-columns': items.length + 1 }}>
    {items.map(item => { const Icon = item.icon || Circle; const badge = item.badgeKey ? badges[item.badgeKey] : 0;
      return <NavLink key={item.path} to={item.path} end={item.path === '/dashboard'} className={({ isActive }) => `office-mobile-navigation__item${isActive ? ' is-active' : ''}`}>
        <span className="office-mobile-navigation__icon"><Icon size={20} strokeWidth={1.8} aria-hidden="true" />{badge > 0 && <span className="office-mobile-navigation__badge" aria-label={`${badge} aguardando resposta`}>{badge > 99 ? '99+' : badge}</span>}</span>
        <span>{item.shortLabel}</span>
      </NavLink>;
    })}
    <button type="button" data-testid="office-bottom-more" className={`office-mobile-navigation__item${expanded || otherPage ? ' is-active' : ''}`} aria-label={expanded ? 'Fechar menu completo' : 'Abrir menu completo'} aria-controls="office-main-sidebar" aria-expanded={expanded} onClick={onMenu}>
      <span className="office-mobile-navigation__icon"><Grid2X2 size={20} strokeWidth={1.8} aria-hidden="true" /></span><span>Mais</span>
    </button>
  </nav>;
}
